import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalNonCriminalCourtActionsModel } from './types';
import legalNonCriminalCourtActionsItemValidator from './validators/item';

const legalNonCriminalCourtActionsValidator: ValidateJSModel<LegalNonCriminalCourtActionsModel> = {
  HasCourtActions: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.HasCourtActions && attributes?.HasCourtActions.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalNonCriminalCourtActionsItemValidator },
      };
    }
    return {};
  },
};

export default legalNonCriminalCourtActionsValidator;
